import RequestAbstract from "./RequestAbstract";

export default class GeneratePost extends RequestAbstract {
  get link() {
    return this.links.accounts + "/generate-post";
  }

  /**
   * GET /generate-post/options
   * Returns all available options for UI (platforms, post types, tones, CTAs, languages)
   * @returns {Promise} Available options for the generate post form
   */
  async getOptions() {
    return await this.getSilent(this.link + "/options");
  }

  /**
   * POST /generate-post
   * Generate post(s) with detailed settings
   *
   * @param {Object} params - Generation parameters
   * @param {string} params.platform - required: instagram, facebook, twitter, linkedin, tiktok, telegram, youtube
   * @param {string} params.topic - required: Post topic
   * @param {string} [params.post_type] - promotional, educational, engagement, announcement, storytelling, behind_the_scenes, tips, testimonial, seasonal, poll, carousel, user_generated
   * @param {string} [params.tone] - professional, casual, humorous, inspirational, urgent, friendly, authoritative, edgy, empathetic, luxurious
   * @param {Object} [params.business_context] - { brand_name, industry, target_audience, brand_voice, unique_selling_point, competitors }
   * @param {Object} [params.product] - { name, description, price, url, promotion }
   * @param {Object} [params.content_settings] - { language, length, include_hashtags, hashtag_count, include_emojis, include_cta, cta_type, custom_cta }
   * @param {string[]} [params.keywords] - Up to 10 keywords
   * @param {number} [params.variations_count] - 1-5
   * @param {number} [params.creativity] - 0-1 (GPT temperature)
   * @param {string} [params.additional_instructions] - Free-form instructions
   * @returns {Promise} Structured JSON with posts, hashtags, timing tips, media recommendations
   */
  async generate(params) {
    return await this.post(this.link, params);
  }
}
